import styled from "styled-components";

export const Wrapper = styled.div`
display: flex;
justify-content: flex-start !important;
align-items: flex-start;
width: 100%;
flex-direction: column;
margin-left: ${(props)=>props.activeStep && '10%'};
`